import { Link, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import DashboardDataTable from 'modules/common/dashboardDataTable.component';
import PropTypes from 'prop-types';
import React from 'react';

// Simple date formatter
const formatDate = (dateString) => {
  if (!dateString) return 'N/A';
  try {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US');
  } catch {
    return 'N/A';
  }
};

const useStyles = makeStyles((theme) => ({
  fileLink: {
    cursor: 'pointer',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  vipStar: {
    color: theme.palette.warning.main,
    marginLeft: theme.spacing(0.5),
  },
  noData: {
    padding: theme.spacing(3),
    textAlign: 'center',
  },
}));

const ActiveFilesGrid = ({ files, isLoading, onFileClick }) => {
  const classes = useStyles();

  const columns = [
    { accessorKey: 'rcName', header: 'RC' },
    {
      accessorKey: 'employeeName',
      header: 'EE Name',
      Cell: ({ row }) => (
        <>
          {row.original.employeeName}
          {row.original.isVIP && <span className={classes.vipStar} role="img" aria-label="VIP">⭐</span>}
        </>
      ),
    },
    { accessorKey: 'clientName', header: 'Client' },
    {
      accessorKey: 'fileNumber',
      header: 'File #',
      Cell: ({ row }) => (
        <Link
          className={classes.fileLink}
          onClick={() => onFileClick(row.original.fileId)}
          color="primary"
        >
          {row.original.fileNumber}
        </Link>
      ),
    },
    { accessorKey: 'relocationPolicy', header: 'Relo Policy' },
    { accessorKey: 'fileType', header: 'File Type' },
    {
      accessorKey: 'initDate',
      header: 'Init Date',
      Cell: ({ cell }) => formatDate(cell.getValue()),
    },
  ];

  if (isLoading) {
    return (
      <Typography className={classes.noData} color="textSecondary">
        Loading active files...
      </Typography>
    );
  }

  if (files.length === 0) {
    return (
      <Typography className={classes.noData} color="textSecondary">
        No active files found.
      </Typography>
    );
  }

  return (
    <DashboardDataTable
      columns={columns}
      data={files}
      initialSorting={[{ id: 'rcName', desc: false }]}
    />
  );
};

ActiveFilesGrid.propTypes = {
  files: PropTypes.arrayOf(
    PropTypes.shape({
      fileId: PropTypes.number.isRequired,
      rcName: PropTypes.string.isRequired,
      fileNumber: PropTypes.string.isRequired,
      clientName: PropTypes.string.isRequired,
      employeeName: PropTypes.string,
      isVIP: PropTypes.bool,
      relocationPolicy: PropTypes.string,
      fileType: PropTypes.string,
      initDate: PropTypes.string,
    }),
  ).isRequired,
  isLoading: PropTypes.bool.isRequired,
  onFileClick: PropTypes.func.isRequired,
};

export default ActiveFilesGrid;
